
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { anonRecord_type, class_type, option_type, record_type, union_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Exception } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ChangelogId_$reflection } from "./Shared.js";

export class ChangedProperty extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EntityCreated", "DynamicProperty", "InventoryNumber", "BusinessUnit", "Category", "StorageSpace", "QrCodeIds", "Unit", "DisplayName", "Description", "AdditionalName", "ImageUrl", "SerialNumber", "Manufacturer", "Comment", "PrinzingCheckNumber", "Model", "LastInspectionDate", "NextInspectionDate", "MaintenanceEndDate", "CommercialDataComment", "WarrantyDate", "PurchasePrice", "SupplierArticleNumber", "Supplier", "PurchaseDate", "Name", "StartDate", "EndDate", "State", "StocktakingScannerRequired", "StocktakingToolsCanBeTaken", "StocktakingHelperAdded", "StocktakingHelperRemoved", "StocktakingResponsiblePersonAdded", "StocktakingResponsiblePersonRemoved", "StocktakingListHelperAdded", "StocktakingListHelperRemoved", "StocktakingListResultAdded", "StocktakingListResultRemoved", "StocktakingListCorrectionAdded", "ReservationName", "ReservationStartDate", "ReservationEndDate", "ReservationReceiver", "ReservationDescription", "ReservationState", "ReservationQuantity", "ReservationStorage", "DocumentName", "DocumentDescription", "DocumentIsVisibleForUserRole", "ReminderDate", "ReminderTitle", "ReminderDescription", "ReminderIsConfirmed", "ReminderConfirmationComment", "ReminderInterval", "ReminderCustomIntervalInterval", "ReminderCustomIntervalValue", "ReminderAdditionalReminderAdded", "ReminderAdditionalReminderRemoved", "ReminderAdditionalRemindersName", "ReminderAdditionalRemindersIntervalInterval", "ReminderAdditionalRemindersIntervalValue", "InspectionResultDate", "InspectionResultValue", "InspectionResultStatus", "InspectionResultComment", "TelematicsConnection", "Trackers"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? this$.fields[0] : ((this$.tag === 2) ? "inventory_number" : ((this$.tag === 3) ? "business_unit" : ((this$.tag === 4) ? "category" : ((this$.tag === 5) ? "storage_space" : ((this$.tag === 6) ? "qr_code_ids" : ((this$.tag === 7) ? "unit" : ((this$.tag === 8) ? "display_name" : ((this$.tag === 9) ? "description" : ((this$.tag === 10) ? "additional_name" : ((this$.tag === 11) ? "image_url" : ((this$.tag === 12) ? "serial_number" : ((this$.tag === 13) ? "manufacturer" : ((this$.tag === 14) ? "comment" : ((this$.tag === 15) ? "prinzing_check_number" : ((this$.tag === 16) ? "model" : ((this$.tag === 17) ? "last_inspection_date" : ((this$.tag === 18) ? "next_inspection_date" : ((this$.tag === 19) ? "maintenance_end_date" : ((this$.tag === 20) ? "commercial_data_comment" : ((this$.tag === 21) ? "warranty_date" : ((this$.tag === 22) ? "purchase_price" : ((this$.tag === 23) ? "supplier_article_number" : ((this$.tag === 24) ? "supplier" : ((this$.tag === 25) ? "purchase_date" : ((this$.tag === 26) ? "name" : ((this$.tag === 27) ? "start_date" : ((this$.tag === 28) ? "end_date" : ((this$.tag === 29) ? "state" : ((this$.tag === 30) ? "stocktaking_scanner_required" : ((this$.tag === 31) ? "stocktaking_tools_can_be_taken" : ((this$.tag === 32) ? "stocktaking_helper_added" : ((this$.tag === 33) ? "stocktaking_helper_removed" : ((this$.tag === 34) ? "stocktaking_responsible_person_added" : ((this$.tag === 35) ? "stocktaking_responsible_person_removed" : ((this$.tag === 36) ? "stocktaking_list_helper_added" : ((this$.tag === 37) ? "stocktaking_list_helper_removed" : ((this$.tag === 38) ? "stocktaking_list_result_added" : ((this$.tag === 39) ? "stocktaking_list_result_removed" : ((this$.tag === 40) ? "stocktaking_list_correction_added" : ((this$.tag === 41) ? "reservation_name" : ((this$.tag === 42) ? "reservation_start_date" : ((this$.tag === 43) ? "reservation_end_date" : ((this$.tag === 44) ? "reservation_receiver" : ((this$.tag === 45) ? "reservation_description" : ((this$.tag === 46) ? "reservation_state" : ((this$.tag === 47) ? "reservation_quantity" : ((this$.tag === 48) ? "reservation_storage" : ((this$.tag === 49) ? "document_name" : ((this$.tag === 50) ? "document_description" : ((this$.tag === 51) ? "document_is_visible_for_user_role" : ((this$.tag === 52) ? "reminder_date" : ((this$.tag === 53) ? "reminder_title" : ((this$.tag === 54) ? "reminder_description" : ((this$.tag === 55) ? "reminder_is_confirmed" : ((this$.tag === 56) ? "reminder_confirmation_comment" : ((this$.tag === 57) ? "reminder_interval" : ((this$.tag === 58) ? "reminder_custom_interval_interval" : ((this$.tag === 59) ? "reminder_custom_interval_value" : ((this$.tag === 60) ? "reminder_additional_reminders_added" : ((this$.tag === 61) ? "reminder_additional_reminders_removed" : ((this$.tag === 62) ? "reminder_additional_reminders_name" : ((this$.tag === 63) ? "reminder_additional_reminders_interval_interval" : ((this$.tag === 64) ? "reminder_additional_reminders_interval_value" : ((this$.tag === 65) ? "inspection_result_date" : ((this$.tag === 66) ? "inspection_result_value" : ((this$.tag === 67) ? "inspection_result_status" : ((this$.tag === 68) ? "inspection_result_comment" : ((this$.tag === 69) ? "telematics_connection" : ((this$.tag === 70) ? "trackers" : "event_created")))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    }
}

export function ChangedProperty_$reflection() {
    return union_type("Shared.Changelog.ChangedProperty", [], ChangedProperty, () => [[], [["Item", string_type]], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function ChangedProperty__ToI18nString(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[0];
        case 2:
            return "general.inventory_number";
        case 3:
            return "business_units.business_unit";
        case 4:
            return "general.category";
        case 5:
            return "tool.storage_space";
        case 6:
            return "general.qr_codes";
        case 7:
            return "general.unit";
        case 8:
            return "general.name";
        case 9:
            return "general.description";
        case 10:
            return "consumable.additional_name";
        case 11:
            return "general.image";
        case 12:
            return "general.serial_number";
        case 13:
            return "tool.manufacturer";
        case 14:
            return "general.comment";
        case 15:
            return "tool.prinzing.check_number";
        case 16:
            return "tool.model";
        case 17:
            return "tool.last_check";
        case 18:
            return "tool.next_inspection";
        case 19:
            return "tool.maintenance_end_date";
        case 20:
            return "general.comment";
        case 21:
            return "general.gurantee_date";
        case 22:
            return "general.purchase_price";
        case 23:
            return "general.supplier_article_number";
        case 24:
            return "general.supplier";
        case 25:
            return "general.purchase_date";
        case 26:
            return "general.name";
        case 27:
            return "general.start_date";
        case 28:
            return "general.end_date";
        case 29:
            return "changelog.state";
        case 30:
            return "changelog.stocktaking_scanner_required";
        case 31:
            return "changelog.stocktaking_tools_can_be_taken";
        case 32:
            return "changelog.stocktaking_helper_added";
        case 33:
            return "changelog.stocktaking_helper_removed";
        case 34:
            return "changelog.stocktaking_responsible_person_added";
        case 35:
            return "changelog.stocktaking_responsible_person_removed";
        case 36:
            return "changelog.stocktaking_list_helper_added";
        case 37:
            return "changelog.stocktaking_list_helper_removed";
        case 38:
            return "changelog.stocktaking_list_result_added";
        case 39:
            return "changelog.stocktaking_list_result_removed";
        case 40:
            return "changelog.stocktaking_list_correction_added";
        case 41:
            return "general.name";
        case 42:
            return "general.start_date";
        case 43:
            return "general.end_date";
        case 44:
            return "general.receiver";
        case 45:
            return "general.description";
        case 46:
            return "changelog.state";
        case 47:
            return "changelog.quantity";
        case 48:
            return "general.storage";
        case 49:
            return "general.name";
        case 50:
            return "general.description";
        case 51:
            return "general.visible_for_user_role";
        case 52:
            return "general.date";
        case 53:
            return "general.title";
        case 54:
            return "general.description";
        case 55:
            return "general.mark_as_done";
        case 56:
            return "general.comment";
        case 57:
            return "reminder_dialog.interval";
        case 58:
            return "reminder_dialog.interval";
        case 59:
            return "reminder_dialog.interval";
        case 60:
            return "reminder.additional_reminder_added";
        case 61:
            return "reminder.additional_reminder_removed";
        case 62:
            return "reminder_dialog.note_text";
        case 63:
            return "reminder_dialog.note_time";
        case 64:
            return "reminder_dialog.note_time";
        case 65:
            return "inspection_result.date";
        case 66:
            return "inspection_result.result";
        case 67:
            return "inspection_result.status";
        case 68:
            return "general.comment";
        case 69:
            return "changelog.telematics_connection";
        case 70:
            return "changelog.trackers";
        default:
            return "event.created";
    }
}

export function ChangedProperty_Parse_Z721C83C5(value) {
    switch (value) {
        case "event_created":
            return new ChangedProperty(0, []);
        case "inventory_number":
            return new ChangedProperty(2, []);
        case "business_unit":
            return new ChangedProperty(3, []);
        case "category":
            return new ChangedProperty(4, []);
        case "storage_space":
            return new ChangedProperty(5, []);
        case "qr_code_ids":
            return new ChangedProperty(6, []);
        case "unit":
            return new ChangedProperty(7, []);
        case "display_name":
            return new ChangedProperty(8, []);
        case "description":
            return new ChangedProperty(9, []);
        case "additional_name":
            return new ChangedProperty(10, []);
        case "image_url":
            return new ChangedProperty(11, []);
        case "serial_number":
            return new ChangedProperty(12, []);
        case "manufacturer":
            return new ChangedProperty(13, []);
        case "comment":
            return new ChangedProperty(14, []);
        case "prinzing_check_number":
            return new ChangedProperty(15, []);
        case "model":
            return new ChangedProperty(16, []);
        case "last_inspection_date":
            return new ChangedProperty(17, []);
        case "next_inspection_date":
            return new ChangedProperty(18, []);
        case "maintenance_end_date":
            return new ChangedProperty(19, []);
        case "commercial_data_comment":
            return new ChangedProperty(20, []);
        case "warranty_date":
            return new ChangedProperty(21, []);
        case "purchase_price":
            return new ChangedProperty(22, []);
        case "supplier_article_number":
            return new ChangedProperty(23, []);
        case "supplier":
            return new ChangedProperty(24, []);
        case "purchase_date":
            return new ChangedProperty(25, []);
        case "name":
            return new ChangedProperty(26, []);
        case "start_date":
            return new ChangedProperty(27, []);
        case "end_date":
            return new ChangedProperty(28, []);
        case "state":
            return new ChangedProperty(29, []);
        case "stocktaking_scanner_required":
            return new ChangedProperty(30, []);
        case "stocktaking_tools_can_be_taken":
            return new ChangedProperty(31, []);
        case "stocktaking_helper_added":
            return new ChangedProperty(32, []);
        case "stocktaking_helper_removed":
            return new ChangedProperty(33, []);
        case "stocktaking_responsible_person_added":
            return new ChangedProperty(34, []);
        case "stocktaking_responsible_person_removed":
            return new ChangedProperty(35, []);
        case "stocktaking_list_helper_added":
            return new ChangedProperty(36, []);
        case "stocktaking_list_helper_removed":
            return new ChangedProperty(37, []);
        case "stocktaking_list_result_added":
            return new ChangedProperty(38, []);
        case "stocktaking_list_result_removed":
            return new ChangedProperty(39, []);
        case "stocktaking_list_correction_added":
            return new ChangedProperty(40, []);
        case "reservation_name":
            return new ChangedProperty(41, []);
        case "reservation_start_date":
            return new ChangedProperty(42, []);
        case "reservation_end_date":
            return new ChangedProperty(43, []);
        case "reservation_receiver":
            return new ChangedProperty(44, []);
        case "reservation_description":
            return new ChangedProperty(45, []);
        case "reservation_state":
            return new ChangedProperty(46, []);
        case "reservation_quantity":
            return new ChangedProperty(47, []);
        case "reservation_storage":
            return new ChangedProperty(48, []);
        case "document_name":
            return new ChangedProperty(49, []);
        case "document_description":
            return new ChangedProperty(50, []);
        case "document_is_visible_for_user_role":
            return new ChangedProperty(51, []);
        case "reminder_date":
            return new ChangedProperty(52, []);
        case "reminder_title":
            return new ChangedProperty(53, []);
        case "reminder_description":
            return new ChangedProperty(54, []);
        case "reminder_is_confirmed":
            return new ChangedProperty(55, []);
        case "reminder_confirmation_comment":
            return new ChangedProperty(56, []);
        case "reminder_interval":
            return new ChangedProperty(57, []);
        case "reminder_custom_interval_interval":
            return new ChangedProperty(58, []);
        case "reminder_custom_interval_value":
            return new ChangedProperty(59, []);
        case "reminder_additional_reminders_added":
            return new ChangedProperty(60, []);
        case "reminder_additional_reminders_removed":
            return new ChangedProperty(61, []);
        case "reminder_additional_reminders_name":
            return new ChangedProperty(62, []);
        case "reminder_additional_reminders_interval_interval":
            return new ChangedProperty(63, []);
        case "reminder_additional_reminders_interval_value":
            return new ChangedProperty(64, []);
        case "inspection_result_date":
            return new ChangedProperty(65, []);
        case "inspection_result_value":
            return new ChangedProperty(66, []);
        case "inspection_result_status":
            return new ChangedProperty(67, []);
        case "inspection_result_comment":
            return new ChangedProperty(68, []);
        case "telematics_connection":
            return new ChangedProperty(69, []);
        case "trackers":
            return new ChangedProperty(70, []);
        case "":
            throw new Exception("Invalid empty changed property name");
        default:
            return new ChangedProperty(1, [value]);
    }
}

export class EntityType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Consumable", "Set", "Receiver", "Storage", "Location", "Category", "Stocktaking", "StocktakingList", "Reservation", "Document", "Reminder", "InspectionResult", "Customer"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "tool_with_quantity" : ((this$.tag === 2) ? "consumable" : ((this$.tag === 3) ? "set" : ((this$.tag === 4) ? "receiver" : ((this$.tag === 5) ? "storage" : ((this$.tag === 6) ? "location" : ((this$.tag === 7) ? "category" : ((this$.tag === 8) ? "stocktaking" : ((this$.tag === 9) ? "stocktaking_list" : ((this$.tag === 10) ? "reservation" : ((this$.tag === 11) ? "document" : ((this$.tag === 12) ? "reminder" : ((this$.tag === 13) ? "inspection_result" : ((this$.tag === 14) ? "customer" : "tool")))))))))))));
    }
}

export function EntityType_$reflection() {
    return union_type("Shared.Changelog.EntityType", [], EntityType, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function EntityType_Parse_Z721C83C5(value) {
    switch (value) {
        case "tool":
            return new EntityType(0, []);
        case "tool_with_quantity":
            return new EntityType(1, []);
        case "consumable":
            return new EntityType(2, []);
        case "set":
            return new EntityType(3, []);
        case "receiver":
            return new EntityType(4, []);
        case "storage":
            return new EntityType(5, []);
        case "location":
            return new EntityType(6, []);
        case "category":
            return new EntityType(7, []);
        case "stocktaking":
            return new EntityType(8, []);
        case "stocktaking_list":
            return new EntityType(9, []);
        case "reservation":
            return new EntityType(10, []);
        case "document":
            return new EntityType(11, []);
        case "reminder":
            return new EntityType(12, []);
        case "inspection_result":
            return new EntityType(13, []);
        case "customer":
            return new EntityType(14, []);
        default:
            throw new Exception(concat("Unexpected entity type ", ...value));
    }
}

export class Entity extends Record {
    constructor(EntityId, EntityType) {
        super();
        this.EntityId = EntityId;
        this.EntityType = EntityType;
    }
}

export function Entity_$reflection() {
    return record_type("Shared.Changelog.Entity", [], Entity, () => [["EntityId", string_type], ["EntityType", EntityType_$reflection()]]);
}

export class Changelog extends Record {
    constructor(Id, Entity, NewValueReferencedEntity, OldValueReferencedEntity, ReferencedEntity, Event$, NewValue, OldValue, Timestamp, UpdatedByUserId) {
        super();
        this.Id = Id;
        this.Entity = Entity;
        this.NewValueReferencedEntity = NewValueReferencedEntity;
        this.OldValueReferencedEntity = OldValueReferencedEntity;
        this.ReferencedEntity = ReferencedEntity;
        this.Event = Event$;
        this.NewValue = NewValue;
        this.OldValue = OldValue;
        this.Timestamp = Timestamp;
        this.UpdatedByUserId = UpdatedByUserId;
    }
}

export function Changelog_$reflection() {
    return record_type("Shared.Changelog.Changelog", [], Changelog, () => [["Id", ChangelogId_$reflection()], ["Entity", Entity_$reflection()], ["NewValueReferencedEntity", option_type(Entity_$reflection())], ["OldValueReferencedEntity", option_type(Entity_$reflection())], ["ReferencedEntity", option_type(Entity_$reflection())], ["Event", ChangedProperty_$reflection()], ["NewValue", string_type], ["OldValue", string_type], ["Timestamp", class_type("System.DateTime")], ["UpdatedByUserId", string_type]]);
}

export class ChangelogEntityDto extends Record {
    constructor(EntityName, EntityId, EntityType) {
        super();
        this.EntityName = EntityName;
        this.EntityId = EntityId;
        this.EntityType = EntityType;
    }
}

export function ChangelogEntityDto_$reflection() {
    return record_type("Shared.Changelog.ChangelogEntityDto", [], ChangelogEntityDto, () => [["EntityName", string_type], ["EntityId", string_type], ["EntityType", EntityType_$reflection()]]);
}

export class ChangelogDto extends Record {
    constructor(Id, ChangedProperty, NewValue, OldValue, NewValueReferencedEntity, OldValueReferencedEntity, ReferencedEntity, Timestamp, UpdatedByUser) {
        super();
        this.Id = Id;
        this.ChangedProperty = ChangedProperty;
        this.NewValue = NewValue;
        this.OldValue = OldValue;
        this.NewValueReferencedEntity = NewValueReferencedEntity;
        this.OldValueReferencedEntity = OldValueReferencedEntity;
        this.ReferencedEntity = ReferencedEntity;
        this.Timestamp = Timestamp;
        this.UpdatedByUser = UpdatedByUser;
    }
}

export function ChangelogDto_$reflection() {
    return record_type("Shared.Changelog.ChangelogDto", [], ChangelogDto, () => [["Id", ChangelogId_$reflection()], ["ChangedProperty", string_type], ["NewValue", string_type], ["OldValue", string_type], ["NewValueReferencedEntity", option_type(ChangelogEntityDto_$reflection())], ["OldValueReferencedEntity", option_type(ChangelogEntityDto_$reflection())], ["ReferencedEntity", option_type(ChangelogEntityDto_$reflection())], ["Timestamp", class_type("System.DateTime")], ["UpdatedByUser", anonRecord_type(["Name", string_type], ["UserId", string_type])]]);
}

export function Helper_changelogMessage(changelog) {
    if (changelog.OldValue === "") {
        return changelog.NewValue;
    }
    else {
        return concat(changelog.OldValue, " -> ", ...changelog.NewValue);
    }
}

export function Helper_displayHistoryComment(eventName, comment) {
    if (comment === "") {
        return eventName;
    }
    else {
        return concat(eventName, ": ", ...comment);
    }
}

